import { fetchData } from '@/utils/requests';
import { create } from 'zustand';

type Team = {
    name: string;
    team_id: number;
};

interface BypassTeamsState {
    teamsBypass: Team[];
    setTeamsBypass: (data: Team[]) => void;
    loaded: boolean;
    setLoaded: (loaded: boolean) => void;
}

const useBypassTeamsStore = create<BypassTeamsState>((set) => ({
    teamsBypass: [],
    setTeamsBypass: (data: Team[]) => set({ teamsBypass: data }),
    loaded: false,
    setLoaded: (loaded: boolean) => set({ loaded: loaded }),
}));

const refreshBypassTeams = () => {
    fetchData("/api/bypass_teams", (data: Team[]) => {
        useBypassTeamsStore.getState().setTeamsBypass(data);
        useBypassTeamsStore.getState().setLoaded(true);
    });
};

export { useBypassTeamsStore, refreshBypassTeams };